<template>
    <div ref="leasingTileContent" class="leasing">
        <table-title>Лизинг</table-title>
        <template v-if="auth">
            <template v-if="list.length">
                <ul class="leasing__list list">
                    <item
                        v-for="(l, i) in renderList"
                        :key="i"
                        :leasing="l" 
                    />
                </ul>
                <span class="leasing__count-message" v-if="totalActive">
                    <b>Общее количество действующих договоров лизинга:</b> <span class="count">{{ totalActive }}</span>
                </span>
            </template>
            <p v-else class="empty-message">Информация о лизингах отсутствует</p>
        </template>
        <demo-message v-else />
    </div>
</template>

<script>
import tableTitle from '@/components/ui/tableTitle.vue.js'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import leasingListItem from '@/components/card/zalogLeasing/leasing/leasingListItem.vue'

export default {
    props: {
        list: Array
    },
    components: {
        tableTitle,
        demoMessage,
        item: leasingListItem
    },
    computed: {
        renderList() { return this.list?.length > 4 ? this.list.slice(0, 4) : this.list },
        totalActive() { return this.$store.state.card?.zalogLeasing?.leasing?.totalActive }
    }
}
</script>

<style lang="sass" scoped>
.leasing
    .list
        padding: 0
        margin: 0
    &__count-message
        display: inline-block
        padding-top: 25px
        font-size: 14px
        b   
            text-decoration: underline
        .count
            font-size: 16px
    .empty-message
        color: #777
        margin-bottom: 15px
        font-size: 16px
        line-height: 18px
</style>